import { render, staticRenderFns } from "./InterForm.vue?vue&type=template&id=6acc8cae&scoped=true&"
import script from "./InterForm.vue?vue&type=script&lang=js&"
export * from "./InterForm.vue?vue&type=script&lang=js&"
import style0 from "./InterForm.vue?vue&type=style&index=0&id=6acc8cae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acc8cae",
  null
  
)

export default component.exports